<template>
    <div class="card" v-bind:class="[this.widthType]">
        <slot />
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export enum WidthType {
    third = 'third',
    twoThirds = 'twoThirds',
    fullWidth = 'fullWidth',
}

export default defineComponent({
    props: {
        widthType: String as PropType<WidthType>,
    },
});
</script>

<style>
.card {
    margin: 30px 15px;
    overflow: hidden;
    border-radius: 10px;
    background-color: var(--white);
}
@media screen and (min-width: 980px) {
    .card {
        margin: 0;
        min-width: 300px;
        height: 45%;
        display: flex;
        flex-direction: column;
    }
    .third {
        width: 32%;
        margin-bottom: 1%;
        margin-right: 1%;
    }
    .twoThirds {
        width: 65%;
        margin-bottom: 1%;
        margin-right: 1%;
    }
    .fullWidth {
        width: 100%;
    }
}
@media (max-width: 1005px) and (min-width: 980px) {
    .card {
        margin: 15px 30px;
    }
}
</style>
